module.exports = __webpack_public_path__ + "static/media/damaha_daaa_chandrabindu.45775c77.ogg";